import { render, staticRenderFns } from "./pianqu2.vue?vue&type=template&id=5cd6df94&scoped=true"
import script from "./pianqu2.vue?vue&type=script&lang=js"
export * from "./pianqu2.vue?vue&type=script&lang=js"
import style0 from "./pianqu2.vue?vue&type=style&index=0&id=5cd6df94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd6df94",
  null
  
)

export default component.exports